import styled from 'styled-components';

const RootWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  margin: 0px;
  padding: 0px;
`;

export default RootWrapper;
